import { render, staticRenderFns } from "./RateTaxPersonTable.vue?vue&type=template&id=3d37a0e4&scoped=true"
import script from "./RateTaxPersonTable.vue?vue&type=script&lang=js"
export * from "./RateTaxPersonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37a0e4",
  null
  
)

export default component.exports